import angular from 'angular';

import cadastralReferenceFormComponent from './cadastralReferenceForm.component';

let cadastralReferenceFormModule = angular.module('cadastralReferenceForm', [
])

.component('cadastralReferenceForm', cadastralReferenceFormComponent)

.name;

export default cadastralReferenceFormModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/cadastralReferenceForm/cadastralReferenceForm.js